'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'concat',
    immutable: 'concat',
    array: function array() {
        for (var _len = arguments.length, newValues = Array(_len), _key = 0; _key < _len; _key++) {
            newValues[_key] = arguments[_key];
        }

        return function (item) {
            return item.concat.apply(item, newValues);
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/concat.js
// module id = 898
// module chunks = 35783957827783